/* istanbul ignore file */
import { calculateSeconds } from '@alfa-bank/site-helpers-transform/time/calculate-seconds';

export const getDeliveryDay = (breakpoint?: string): string => {
    if (!breakpoint) return 'tomorrow';

    const breakpointDay = new Date();
    const [hours = 0, minutes = 0, seconds = 0] = breakpoint
        .split(':')
        .map((str: string) => parseInt(str, 10) || 0);

    breakpointDay.setHours(hours, minutes, seconds);

    return calculateSeconds(breakpointDay) > 0 ? 'today' : 'tomorrow';
};
